import { BaseCommand } from '../../../core/commands/ICommand';

export type PositionScenarioTransition = 'apply' | 'discard' | 'rebase';

export interface PositionScenarioTransitionPort {
  execute(): Promise<void>;
  undo(): Promise<void>;
  redo(): Promise<void>;
}

/** Command-history boundary for durable scenario lifecycle transitions. */
export class PositionScenarioTransitionCommand extends BaseCommand {
  constructor(private readonly input: {
    action: PositionScenarioTransition;
    canUseScenarios: boolean;
    serverPort: PositionScenarioTransitionPort;
  }) {
    super(`${capitalize(input.action)} Position Scenario`);
  }

  canExecute(): boolean { return this.input.canUseScenarios; }

  execute(): Promise<void> {
    if (!this.canExecute()) throw new Error('Position scenarios are not available for this workspace.');
    return this.input.serverPort.execute();
  }

  undo(): Promise<void> { return this.input.serverPort.undo(); }
  redo(): Promise<void> { return this.input.serverPort.redo(); }
}

function capitalize(value: string): string {
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
}
